
export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)), url('https://readdy.ai/api/search-image?query=Modern%20nail%20art%20studio%20with%20colorful%20nail%20polish%20bottles%2C%20professional%20nail%20tools%2C%20and%20elegant%20manicure%20setup%20in%20a%20bright%2C%20clean%2C%20minimalist%20environment%20with%20soft%20pastel%20colors%20and%20natural%20lighting%20creating%20a%20welcoming%20atmosphere%20for%20both%20men%20and%20women&width=1920&height=1080&seq=hero-nail-studio&orientation=landscape')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-white/90 via-white/70 to-transparent"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="w-full max-w-4xl">
          <div className="text-left">
            <h2 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
              <span className="bg-gradient-to-r from-pink-500 to-teal-500 bg-clip-text text-transparent">
                美しい指先で
              </span>
              <br />
              <span className="text-gray-800">
                自分らしさを表現
              </span>
            </h2>
            
            <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-2xl leading-relaxed">
              性別を問わず、すべての方に質の高いネイルサービスを。
              <br />
              プロフェッショナルなレッスンから商品販売まで、
              <br />
              あなたのネイルライフをトータルサポートします。
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={scrollToContact}
                className="bg-gradient-to-r from-pink-500 to-teal-500 text-white px-8 py-4 rounded-full text-lg font-semibold hover:shadow-xl transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                無料相談を予約
              </button>
              <button 
                onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
                className="border-2 border-pink-500 text-pink-500 px-8 py-4 rounded-full text-lg font-semibold hover:bg-pink-500 hover:text-white transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-arrow-down-line mr-2"></i>
                サービス詳細
              </button>
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-2xl text-gray-400"></i>
      </div>
    </section>
  );
}
